import { useState, useEffect } from 'react';
import api from '../api';

const STATUSY = ['PRZYGOTOWANIE', 'WYSLANE', 'GOTOWE', 'W_DRODZE', 'ZAKONCZONE'];

export default function NewOrder({ onSave, onCancel }) {
  const [form, setForm] = useState({
    nazwa_kolekcji: '',
    fabryka_id: '',
    status: 'PRZYGOTOWANIE',
  });
  const [factories, setFactories] = useState([]);
  const [loadingFactories, setLoadingFactories] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const user = JSON.parse(localStorage.getItem('user') || '{}');

  useEffect(() => {
    api.get('/factories')
      .then(res => setFactories(res.data))
      .catch(() => setError('Nie udało się pobrać listy fabryk'))
      .finally(() => setLoadingFactories(false));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      await api.post('/orders', {
        nazwa_kolekcji: form.nazwa_kolekcji,
        fabryka_id: form.fabryka_id ? parseInt(form.fabryka_id) : null,
        status: form.status,
        created_by: user.id,
      });
      onSave();
    } catch (err) {
      setError(err.response?.data?.error || 'Błąd zapisu zamówienia');
      setSaving(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.header}>
        <div>
          <h2 style={s.pageTitle}>Nowe zamówienie</h2>
          <p style={s.pageSubtitle}>Wypełnij podstawowe dane zamówienia</p>
        </div>
      </div>

      <div style={s.formCard}>
        <form onSubmit={handleSubmit}>
          {/* nazwa_kolekcji */}
          <div style={s.field}>
            <label style={s.label}>Nazwa kolekcji *</label>
            <input
              style={s.input}
              value={form.nazwa_kolekcji}
              onChange={e => setForm({ ...form, nazwa_kolekcji: e.target.value })}
              placeholder="np. Wiosna 2025"
              required
              autoFocus
            />
          </div>

          {/* fabryka_id */}
          <div style={s.field}>
            <label style={s.label}>Fabryka</label>
            {loadingFactories ? (
              <div style={s.selectPlaceholder}>Ładowanie fabryk...</div>
            ) : (
              <select
                style={s.input}
                value={form.fabryka_id}
                onChange={e => setForm({ ...form, fabryka_id: e.target.value })}
              >
                <option value="">— Wybierz fabrykę —</option>
                {factories.map(f => (
                  <option key={f.id} value={f.id}>{f.nazwa}</option>
                ))}
              </select>
            )}
          </div>

          {/* status */}
          <div style={s.field}>
            <label style={s.label}>Status</label>
            <select
              style={s.input}
              value={form.status}
              onChange={e => setForm({ ...form, status: e.target.value })}
            >
              {STATUSY.map(st => (
                <option key={st} value={st}>{st}</option>
              ))}
            </select>
          </div>

          {error && <p style={s.errorText}>{error}</p>}

          <div style={s.footer}>
            <button type="button" style={s.btnCancel} onClick={onCancel} disabled={saving}>
              Anuluj
            </button>
            <button type="submit" style={s.btnPrimary} disabled={saving || loadingFactories}>
              {saving ? 'Zapisywanie...' : 'Zapisz zamówienie'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const s = {
  page: { padding: '32px', color: '#e6edf3' },

  header: { marginBottom: '24px' },
  pageTitle: { margin: '0 0 4px', fontSize: '22px', fontWeight: '700', color: '#e6edf3' },
  pageSubtitle: { margin: 0, color: '#8b949e', fontSize: '14px' },

  formCard: {
    background: '#161b22', border: '1px solid #30363d', borderRadius: '10px',
    maxWidth: '560px', boxShadow: '0 1px 4px rgba(0,0,0,0.4)',
  },

  field: { padding: '16px 24px 0' },
  label: { display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '500', color: '#c9d1d9' },
  input: {
    width: '100%', padding: '9px 12px', border: '1px solid #30363d', borderRadius: '6px',
    fontSize: '14px', boxSizing: 'border-box', background: '#0d1117', color: '#c9d1d9',
    outline: 'none',
  },
  selectPlaceholder: { padding: '9px 12px', color: '#484f58', fontSize: '14px' },

  errorText: { color: '#ff7875', fontSize: '13px', margin: '12px 24px 0' },

  footer: { display: 'flex', justifyContent: 'flex-end', gap: '10px', padding: '20px 24px' },
  btnPrimary: {
    padding: '10px 20px', background: '#1890ff', color: 'white', border: 'none',
    borderRadius: '6px', fontSize: '14px', cursor: 'pointer', fontWeight: '500',
  },
  btnCancel: {
    padding: '10px 20px', background: '#21262d', color: '#c9d1d9',
    border: '1px solid #30363d', borderRadius: '6px', fontSize: '14px', cursor: 'pointer',
  },
};
